<script setup>
  import {ref} from "vue";

  import ComponentIcon from "@components/Icons/Icon.vue";
  import ComponentDosageInput from "@components/Inputs/DosageInput.vue";
  import ComponentFullDateInput from "@components/Inputs/FullDateInput.vue";
  import ComponentInput from "@components/Inputs/Input.vue";
  import ComponentRange from "@components/Inputs/Range.vue";
  import ComponentSelect from "@components/Selects/Select.vue";

  defineOptions({
    name: "PagesDevInputFields",
  });

  const inputValue = ref(null);
  const selectValue = ref(null);
  const dateValue = ref(null);
</script>

<template>
  <div class="grid grid-cols-3 gap-4 md:grid-cols-12">
    <div class="col-span-4 flex flex-col space-y-4">
      <h1>Default</h1>

      <ComponentInput v-model="inputValue" label="Input" placeholder="Placeholder" helper-text="Helper Text" />

      <hr class="border-2 border-green-50" />

      <ComponentInput
        v-model="inputValue"
        hide-clear
        label="Input [hide-clear]"
        placeholder="Placeholder"
        helper-text="Helper Text"
      />

      <hr class="border-2 border-green-50" />

      <ComponentInput v-model="inputValue" label="Input with Icon" placeholder="Placeholder" helper-text="Helper Text">
        <template #icon><ComponentIcon class="text-xl text-gray-600">search</ComponentIcon></template>
      </ComponentInput>

      <hr class="border-2 border-green-50" />

      <ComponentSelect v-model="selectValue" label="Select" helper-text="Helper Text">
        <option>Option 1</option>
        <option>Option 2</option>
      </ComponentSelect>

      <hr class="border-2 border-green-50" />

      <ComponentFullDateInput v-model="dateValue" helper-text="Helper Text" label="Full Date Input" />

      <hr class="border-2 border-green-50" />

      <div class="h-20">
        <ComponentDosageInput name="morning" />
      </div>

      <hr class="border-2 border-green-50" />

      <ComponentInput
        v-model="inputValue"
        type="password"
        maxlength="3"
        label="Input[password]"
        placeholder="Placeholder"
        helper-text="Helper Text"
      />

      <hr class="border-2 border-green-50" />

      <ComponentInput
        v-model="inputValue"
        hide-clear
        label="Input[suffix]"
        placeholder="Placeholder"
        helper-text="Helper Text"
      >
        <template #suffix>suffix</template>
      </ComponentInput>

      <hr class="border-2 border-green-50" />

      <ComponentRange label="Range" :datalist="['a', 'b', 'c']" />
    </div>

    <div class="col-span-4 flex flex-col space-y-4">
      <h1>Disabled</h1>

      <ComponentInput v-model="inputValue" disabled label="Input" placeholder="Placeholder" helper-text="Helper Text" />

      <hr class="border-2 border-green-50" />

      <ComponentInput
        v-model="inputValue"
        disabled
        hide-clear
        label="Input [hide-clear]"
        placeholder="Placeholder"
        helper-text="Helper Text"
      />

      <hr class="border-2 border-green-50" />

      <ComponentInput
        v-model="inputValue"
        disabled
        label="Input with Icon"
        placeholder="Placeholder"
        helper-text="Helper Text"
      >
        <template #icon><ComponentIcon class="text-xl text-gray-600">search</ComponentIcon></template>
      </ComponentInput>

      <hr class="border-2 border-green-50" />

      <ComponentSelect v-model="selectValue" disabled label="Select" helper-text="Helper Text">
        <option>Option 1</option>
        <option>Option 2</option>
      </ComponentSelect>

      <hr class="border-2 border-green-50" />

      <ComponentFullDateInput v-model="dateValue" helper-text="Helper Text" disabled label="Full Date Input" />

      <hr class="border-2 border-green-50" />

      <div class="h-20">
        <ComponentDosageInput disabled name="morning" />
      </div>

      <hr class="border-2 border-green-50" />

      <ComponentInput
        v-model="inputValue"
        disabled
        type="password"
        maxlength="3"
        label="Input[password]"
        placeholder="Placeholder"
        helper-text="Helper Text"
      />

      <hr class="border-2 border-green-50" />

      <ComponentInput
        v-model="inputValue"
        disabled
        hide-clear
        label="Input[suffix]"
        placeholder="Placeholder"
        helper-text="Helper Text"
      >
        <template #suffix>suffix</template>
      </ComponentInput>

      <hr class="border-2 border-green-50" />

      <ComponentRange disabled label="Range" :datalist="['a', 'b', 'c']" />
    </div>

    <div class="col-span-4 flex flex-col space-y-4">
      <h1>Validation</h1>

      <ComponentInput
        v-model="inputValue"
        validation="Validation"
        label="Input"
        placeholder="Placeholder"
        helper-text="Helper Text"
      />

      <hr class="border-2 border-green-50" />

      <ComponentInput
        v-model="inputValue"
        validation="Validation"
        hide-clear
        label="Input [hide-clear]"
        placeholder="Placeholder"
        helper-text="Helper Text"
      />

      <hr class="border-2 border-green-50" />

      <ComponentInput
        v-model="inputValue"
        validation="Validation"
        label="Input with Icon"
        placeholder="Placeholder"
        helper-text="Helper Text"
      >
        <template #icon><ComponentIcon class="text-xl text-gray-600">search</ComponentIcon></template>
      </ComponentInput>

      <hr class="border-2 border-green-50" />

      <ComponentSelect v-model="selectValue" validation="Validation" label="Select" helper-text="Helper Text">
        <option>Option 1</option>
        <option>Option 2</option>
      </ComponentSelect>

      <hr class="border-2 border-green-50" />

      <ComponentFullDateInput
        v-model="dateValue"
        helper-text="Helper Text"
        validation="Validation called Error here"
        label="Full Date Input"
      />

      <hr class="border-2 border-green-50" />

      <div class="h-20">
        <ComponentDosageInput value="a" name="morning" />
      </div>

      <hr class="border-2 border-green-50" />

      <ComponentInput
        v-model="inputValue"
        validation="Validation"
        type="password"
        maxlength="3"
        label="Input[password]"
        placeholder="Placeholder"
        helper-text="Helper Text"
      />

      <hr class="border-2 border-green-50" />

      <ComponentInput
        v-model="inputValue"
        validation="Validation"
        hide-clear
        label="Input[suffix]"
        placeholder="Placeholder"
        helper-text="Helper Text"
      >
        <template #suffix>suffix</template>
      </ComponentInput>

      <hr class="border-2 border-green-50" />

      <ComponentRange validation="Validation" label="Range" :datalist="['a', 'b', 'c']" />
    </div>
  </div>
</template>
